import { Box, BoxWrapper, SubTitle } from '../style';

import RegPaymentMethod from './RegPaymentMethod';
import UnregPaymentMethod from './UnregPaymentMethod';

import * as styled from './style';
import type { PaymentInfo, GetCompanyInfoResponseProps } from '@/types/company.types';
import Text from '@/components/common/Text';
import { Theme } from '@/styles/Theme';
import { dateFormat } from '@/utils/convertDateFormat';

interface Props {
  paymentData: PaymentInfo;
  companyData?: GetCompanyInfoResponseProps;
}

const PaymentMethodInfo = ({ paymentData, companyData }: Props) => {
  const isPaymentMethodRegisted = !!paymentData.billingKey;
  const subscriptionStatus = companyData?.subscriptionStatus || 'free';
  const paymentMethod = companyData?.paymentMethod;
  const nearPaymentDate = paymentData.nearPaymentDate;
  const subscriptionEndDate = companyData?.subscriptionEndDate;

  // Check if should show card warning
  const shouldShowCardWarning =
    subscriptionStatus === 'active' &&
    paymentMethod === 'prepaid' &&
    !isPaymentMethodRegisted;

  return (
    <BoxWrapper>
      <SubTitle>결제 수단</SubTitle>
      
      {shouldShowCardWarning && (
        <styled.WarningBox>
          <styled.WarningIcon>⚠️</styled.WarningIcon>
          <styled.WarningContent>
            <Text fontSize='1rem' fontWeight={600} color={Theme.colors.WARNING_RED}>
              자동 결제를 사용하려면 카드를 등록해야 합니다
            </Text>
            <Text fontSize='0.875rem' color={Theme.colors.G_1} margin='0.5rem 0 0 0'>
              카드를 등록하지 않으면 다음 결제일(
              {nearPaymentDate
                ? dateFormat(nearPaymentDate)
                : subscriptionEndDate
                ? dateFormat(subscriptionEndDate)
                : 'N/A'}
              )에 자동 결제가 이루어지지 않습니다.
            </Text>
            {paymentMethod === 'prepaid' && (
              <styled.PostpaidInfoLink
                onClick={() => {
                  // Open Channel.IO chat with pre-filled message (not sent)
                  const message = '후불 결제로 변경하고 싶습니다.';
                  if (window.ChannelIO) {
                    window.ChannelIO('openChat', undefined, message);
                  }
                }}
              >
                후불 결제로 변경하려면 영업팀에 문의하세요
              </styled.PostpaidInfoLink>
            )}
          </styled.WarningContent>
        </styled.WarningBox>
      )}

      {/* Prepaid: Show card registration */}
      {paymentMethod === 'prepaid' && (
        <Box>
          {isPaymentMethodRegisted ? (
            <>
              <RegPaymentMethod />
              <styled.PaymentMethodDesc>
                등록하신 결제 카드로 자동 결제가 이루어집니다.
              </styled.PaymentMethodDesc>
            </>
          ) : (
            <>
              <UnregPaymentMethod />
              <styled.PaymentMethodDesc>
                자동 결제에서 사용할 결제 카드를 등록하세요
              </styled.PaymentMethodDesc>
            </>
          )}
        </Box>
      )}

      {/* Postpaid: Show invoice info */}
      {paymentMethod === 'postpaid' && (
        <Box>
          <styled.PostpaidInfoBox>
            <Text fontSize='1rem' fontWeight={600} color={Theme.colors.DG_1} margin='0 0 0.5rem 0'>
              후불 결제 (Invoice)
            </Text>
            <Text fontSize='0.875rem' color={Theme.colors.G_1} margin='0.5rem 0 0 0'>
              후불 결제는 카드 등록이 필요하지 않습니다.
              <br />
              사용 기간 종료 후 영업팀에서 발행한 청구서(Invoice)를 받아보시면 됩니다.
              <br />
              결제 관련 문의사항이 있으시면 영업팀에 연락해주세요.
            </Text>
          </styled.PostpaidInfoBox>
        </Box>
      )}
    </BoxWrapper>
  );
};
export default PaymentMethodInfo;
